import { BMDivider, BMPrimitives, BMText } from "@traveloka/district-bloom";
import IcSystemCrossClose from "@traveloka/icon-kit-web/react/IcSystemCrossClose";
import { Pressable, StyleSheet } from "react-native";
import { FullScreenDialog } from "../../../../components";
import BMView from "../../../../components/View/BMView";
import { appendTestId } from "../../../../utils";
import StickyContainer from "../../Sticky";
import CalendarPicker, { CalendarPickerProps } from "./CalendarPicker";

type Props = CalendarPickerProps & {
  title: string;
  visible: boolean;
  onClose: () => void;
  footerComponent?: React.JSX.Element;
  testID?: string;
};

export default function CalendarPickerFullScreenModal({
  onClose,
  title,
  visible,
  footerComponent,
  testID,
  ...props
}: Props) {
  return (
    <FullScreenDialog visible={visible}>
      <StickyContainer
        headerContent={
          <>
            <BMView
              style={styles.header}
              justify="between"
              align="center"
              row
              spacing="md"
            >
              <BMText variant="titleSmall">{title}</BMText>
              <Pressable
                testID={appendTestId(testID, "close")}
                style={styles.close}
                onPress={onClose}
              >
                <IcSystemCrossClose width={24} height={24} />
              </Pressable>
            </BMView>
            <BMDivider type="SUBTLE" />
          </>
        }
        footerContent={footerComponent}
        hasInsets
      >
        <BMView style={styles.content}>
          <CalendarPicker {...props} />
        </BMView>
      </StickyContainer>
    </FullScreenDialog>
  );
}

const styles = StyleSheet.create({
  header: {
    padding: BMPrimitives.BMSize.md,
  },
  content: {
    marginTop: BMPrimitives.BMSize.lg,
  },
  close: {
    marginLeft: "auto",
  },
});
